<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="p-2">
      <TitleButton
        btnTitle="Add New"
        :showBtn="false"
        :showAddNew="true"
        title="Money Receipt List"
        @onClickAddNewButton="openModal"
      />
    </div>

    <div class="card p-2" style="min-height: 200px">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Voucher Date</th>
              <th>Party Name</th>
              <th>Txn Ref No</th>
              <th>Receipt Amount</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in moneyReceiptList" :key="i">
              <td class="fw-bold">{{ item.receipt_date }}</td>
              <td>{{ item.party }}</td>
              <td>{{ item.voucher_no }}</td>
              <td>{{ commaFormat(item.total_paid_amount) }}</td>
              <td>
                <button class="btn btn-secondary btn-sm"
                        @click="goToPrint(item.id)"
                        style="cursor: pointer"
                >
                  <i class="fas fa-print"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-if="!moneyReceiptList.length" class="text-center mt-5">No data</p>
      </div>
    </div>

    <Loader v-if="loading"/>

    <IpdPharmacyMoneyReceiptModal
      v-if="isModalOpen"
      :ipd-register-id="ipdRegisterId"
      @onClose="isModalOpen = false"
      @onSaved="onSaved"
    />
  </div>
</template>

<script setup>
import {computed, inject, onMounted, ref} from 'vue'
import {useRoute} from 'vue-router'
import TitleButton from '@/components/atom/TitleButton'
import Loader from '@/components/atom/LoaderComponent'
import figureFormatter from '@/services/utils/figureFormatter'
import handleMoneyReceipt from '@/services/moneyReceipt'
import handlePurchase from '@/services/modules/purchase'
import handleCompany from '@/services/modules/company'
import moneyReceiptHelper from '@/services/utils/pdf/moneyReceiptHelper'
import IpdPharmacyMoneyReceiptModal from '@/components/molecule/company/hospital/ipd-pharmacy-bill/IpdPharmacyMoneyReceiptModal.vue'

const $route = useRoute()
const emit = defineEmits(['onSaved'])
const showError = inject('showError')
const {commaFormat} = figureFormatter()
const {fetchPharmacyMoneyReceiptList, loading} = handleMoneyReceipt()
const {fetchMoneyReceipt} = handlePurchase()
const {fetchCompanyInfo} = handleCompany()
const {generatePdf} = moneyReceiptHelper()

const moneyReceiptList = ref([])
const companyInfo = ref({})
const isModalOpen = ref(false)

const companyId = computed(() => $route.params.companyId)
const ipdRegisterId = computed(() => $route.params.ipdRegisterId || $route.query.ipd_register_id)
const contactId = computed(() => $route.query.contactId || $route.query.contact_id || null)

const openModal = () => {
  isModalOpen.value = true
}

const onSaved = () => {
  isModalOpen.value = false
  getMoneyReceiptList()
  emit('onSaved')
}

const getQuery = () => {
  let query = `?company_id=${companyId.value}`
  if (contactId.value) query += '&contact_profile_id=' + contactId.value
  if (ipdRegisterId.value) query += '&ipd_register_id=' + ipdRegisterId.value
  return query
}

const getMoneyReceiptList = () => {
  fetchPharmacyMoneyReceiptList(getQuery()).then(res => {
    if (!res.status) {
      moneyReceiptList.value = []
      return
    }
    moneyReceiptList.value = res.data.data
  }).catch(() => {
    moneyReceiptList.value = []
  })
}

const getCompanyInfo = () => {
  fetchCompanyInfo(companyId.value).then(res => {
    if (res.status) companyInfo.value = res.data
  })
}

const goToPrint = (id) => {
  const companyQuery = `?company_id=${companyId.value}`
  fetchMoneyReceipt(id, companyQuery).then(res => {
    if (!res.status) return
    generatePdf(companyInfo.value, res.data)
  }).catch(() => {
    showError('Something is wrong. Check your connectivity!!')
  })
}

onMounted(() => {
  getMoneyReceiptList()
  getCompanyInfo()
})
</script>
